module.exports = __webpack_public_path__ + "img/boat-icon.10fd6f18.svg";